// extracted by mini-css-extract-plugin
module.exports = {"EditorEmpty":"_3T3ZQ7tL","firstBlock":"uNjs_x_1","titleBlock":"_1mYUM9-X","emptyTitleContainer":"_1eg5cURp","title":"BvpDCMXj","scrollDiv":"_145DoywJ","emptyTitle":"_2RXlFoup","previewButton":"qkiXA8kN","emptyResumeDetails":"_1L_rFMv1","resumeUploadButton":"RQk9fIAw","uploadImageContainer":"_7h65Akg_","candidateImagePlaceholder":"MTp8hSIJ","candidateImageInput":"K0YCQKQq","emptyGenInfoInputs":"g6zf9jtw"};
    if(module.hot) {
      // 1754515036693
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  